
class CacheList {
    constructor() {
        this.cacheList = [];
        this.run = false;
    }
    setCacheItem(cb) {
        this.cacheList.push(()=>{
            cb(()=> {
                this.run = false;
                this.runCacheCb()
            })
        });
        this.runCacheCb();
    }
    runCacheCb() {
        if (this.run) {
            return;
        };
        const frist = this.cacheList.shift();
        if (!frist) {
            this.run = false;
            return
        }
        if (typeof frist === 'function') {
            this.run = true;
            frist()
        }else {
            this.runCacheCb()
        }
    }
};

export default new CacheList();
